const TITOLARE_IT =
  "Il Titolare del trattamento è RR Solutions srl, con sede legale in Via Francesco Olgiati n. 26, Milano, CF e P.IVA 02582720997, R.E.A. MI-2677808, Registro delle Imprese di Milano Monza Brianza e Lodi. Per qualsiasi richiesta relativa alla privacy: info@ethicenergy.it.";
const TITOLARE_EN =
  "The Data Controller is RR Solutions srl, registered office at Via Francesco Olgiati 26, Milan (Italy), Tax Code and VAT no. 02582720997, R.E.A. MI-2677808, Companies Register of Milan Monza Brianza and Lodi. For any privacy request: info@ethicenergy.it.";

export const legalContent = {
  privacy: {
    label: { it: "Documento legale", en: "Legal document" },
    title: { it: "Privacy Policy", en: "Privacy Policy" },
    updated: { it: "Ultimo aggiornamento: agosto 2026", en: "Last updated: August 2026" },
    sections: [
      {
        heading: { it: "1. Titolare del trattamento", en: "1. Data Controller" },
        paragraphs: [{ it: TITOLARE_IT, en: TITOLARE_EN }],
      },
      {
        heading: { it: "2. Dati personali raccolti", en: "2. Personal data we collect" },
        paragraphs: [
          {
            it: "Attraverso il sito raccogliamo esclusivamente i dati che ci fornisci volontariamente tramite il form di contatto e i dati tecnici di navigazione.",
            en: "Through this website we only collect the data you voluntarily provide via the contact form and technical browsing data.",
          },
        ],
        list: [
          {
            it: "Dati identificativi e di contatto: nome, cognome, azienda, ruolo, email, telefono",
            en: "Identity and contact data: name, surname, company, role, email, phone",
          },
          {
            it: "Dati relativi alla richiesta: consumo energetico stimato e contenuto del messaggio",
            en: "Request-related data: estimated energy consumption and message content",
          },
          {
            it: "Dati di navigazione: indirizzo IP, tipo di browser, pagine visitate (in forma aggregata)",
            en: "Browsing data: IP address, browser type, pages visited (in aggregate form)",
          },
        ],
      },
      {
        heading: { it: "3. Finalità e base giuridica", en: "3. Purposes and legal basis" },
        list: [
          {
            it: "Riscontro alle richieste di contatto e diagnostica energetica (art. 6.1.b GDPR — misure precontrattuali)",
            en: "Responding to contact and energy diagnostic requests (art. 6.1.b GDPR — pre-contractual measures)",
          },
          {
            it: "Adempimento di obblighi di legge, regolamenti e normativa comunitaria (art. 6.1.c GDPR)",
            en: "Compliance with legal and regulatory obligations (art. 6.1.c GDPR)",
          },
          {
            it: "Tutela di diritti in sede giudiziaria e prevenzione di abusi (art. 6.1.f GDPR — legittimo interesse)",
            en: "Protection of rights in court and abuse prevention (art. 6.1.f GDPR — legitimate interest)",
          },
        ],
      },
      {
        heading: { it: "4. Modalità di trattamento e conservazione", en: "4. Processing methods and retention" },
        paragraphs: [
          {
            it: "I dati sono trattati con strumenti informatici e misure di sicurezza adeguate a garantirne riservatezza e integrità. I dati inviati tramite il form di contatto sono conservati per un massimo di 24 mesi dalla richiesta, salvo instaurazione di un rapporto contrattuale o diversi obblighi di legge.",
            en: "Data is processed with IT tools and adequate security measures to ensure confidentiality and integrity. Data sent via the contact form is retained for a maximum of 24 months from the request, unless a contractual relationship is established or legal obligations require otherwise.",
          },
        ],
      },
      {
        heading: { it: "5. Comunicazione a terzi", en: "5. Disclosure to third parties" },
        paragraphs: [
          {
            it: "I dati possono essere trattati da fornitori tecnici che operano come responsabili del trattamento (hosting, servizi email, manutenzione del sito), nel rispetto di accordi di riservatezza. I dati non sono mai venduti, ceduti o diffusi a terzi per finalità di marketing.",
            en: "Data may be processed by technical providers acting as data processors (hosting, email services, site maintenance), under confidentiality agreements. Data is never sold, transferred or disclosed to third parties for marketing purposes.",
          },
        ],
      },
      {
        heading: { it: "6. Trasferimenti extra-UE", en: "6. Transfers outside the EU" },
        paragraphs: [
          {
            it: "Alcuni fornitori tecnici possono trattare dati al di fuori dello Spazio Economico Europeo; in tal caso il trasferimento avviene nel rispetto degli artt. 44 e ss. GDPR, sulla base di decisioni di adeguatezza o clausole contrattuali standard.",
            en: "Some technical providers may process data outside the European Economic Area; in such cases the transfer complies with articles 44 et seq. GDPR, based on adequacy decisions or standard contractual clauses.",
          },
        ],
      },
      {
        heading: { it: "7. Diritti dell'interessato", en: "7. Your rights" },
        paragraphs: [
          {
            it: "Ai sensi degli artt. 15–22 GDPR puoi esercitare in qualsiasi momento i diritti di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione scrivendo a info@ethicenergy.it. Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
            en: "Under articles 15–22 GDPR you may exercise at any time the rights of access, rectification, erasure, restriction, portability and objection by writing to info@ethicenergy.it. You also have the right to lodge a complaint with the Italian Data Protection Authority (www.garanteprivacy.it).",
          },
        ],
      },
      {
        heading: { it: "8. Modifiche a questa policy", en: "8. Changes to this policy" },
        paragraphs: [
          {
            it: "La presente informativa può essere aggiornata nel tempo. La versione vigente è sempre quella pubblicata su questa pagina.",
            en: "This policy may be updated over time. The current version is always the one published on this page.",
          },
        ],
      },
    ],
  },
  cookie: {
    label: { it: "Documento legale", en: "Legal document" },
    title: { it: "Cookie Policy", en: "Cookie Policy" },
    updated: { it: "Ultimo aggiornamento: agosto 2026", en: "Last updated: August 2026" },
    sections: [
      {
        heading: { it: "1. Cosa sono i cookie", en: "1. What cookies are" },
        paragraphs: [
          {
            it: "I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. Consentono al sito di funzionare correttamente e di ricordare alcune preferenze.",
            en: "Cookies are small text files that visited websites send to the user's device, where they are stored and retransmitted to the same sites on the next visit. They allow the site to function properly and remember certain preferences.",
          },
        ],
      },
      {
        heading: { it: "2. Cookie tecnici", en: "2. Technical cookies" },
        paragraphs: [
          {
            it: "Questo sito utilizza cookie tecnici strettamente necessari al funzionamento (ad esempio per la sessione dell'area riservata CMS). Questi cookie non richiedono il consenso dell'utente ai sensi della normativa vigente.",
            en: "This website uses technical cookies strictly necessary for its operation (for example, for the CMS restricted area session). These cookies do not require user consent under current regulations.",
          },
        ],
      },
      {
        heading: { it: "3. Cookie di analisi", en: "3. Analytics cookies" },
        paragraphs: [
          {
            it: "Il sito può utilizzare strumenti di analisi di terze parti per raccogliere informazioni statistiche aggregate sull'utilizzo delle pagine (numero di visitatori, pagine più visitate). Questi strumenti non permettono l'identificazione diretta dell'utente.",
            en: "The site may use third-party analytics tools to collect aggregate statistical information about page usage (number of visitors, most visited pages). These tools do not allow direct identification of the user.",
          },
        ],
      },
      {
        heading: { it: "4. Cookie di profilazione", en: "4. Profiling cookies" },
        paragraphs: [
          {
            it: "Questo sito non utilizza cookie di profilazione propri né di terze parti per finalità pubblicitarie o di marketing comportamentale.",
            en: "This website does not use first-party or third-party profiling cookies for advertising or behavioural marketing purposes.",
          },
        ],
      },
      {
        heading: { it: "5. Come gestire i cookie", en: "5. How to manage cookies" },
        paragraphs: [
          {
            it: "Puoi gestire o disattivare i cookie direttamente dalle impostazioni del tuo browser (Chrome, Firefox, Safari, Edge). La disattivazione dei cookie tecnici può compromettere il funzionamento di alcune aree del sito, come l'accesso all'area riservata.",
            en: "You can manage or disable cookies directly from your browser settings (Chrome, Firefox, Safari, Edge). Disabling technical cookies may affect the operation of some areas of the site, such as access to the restricted area.",
          },
        ],
      },
      {
        heading: { it: "6. Titolare e contatti", en: "6. Data Controller and contacts" },
        paragraphs: [{ it: TITOLARE_IT, en: TITOLARE_EN }],
      },
      {
        heading: { it: "7. Aggiornamenti", en: "7. Updates" },
        paragraphs: [
          {
            it: "La presente cookie policy può essere aggiornata nel tempo. Ti invitiamo a consultare periodicamente questa pagina.",
            en: "This cookie policy may be updated over time. Please check this page periodically.",
          },
        ],
      },
    ],
  },
};
